import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import { CartProvider } from './contexts/CartContext';
import { LanguageProvider } from './contexts/LanguageContext';
import HomePage from './pages/HomePage';
import CartPage from './pages/CartPage';
import ConfirmationPage from './pages/ConfirmationPage';
import NotFoundPage from './pages/NotFoundPage';
import ProductDetailPage from './pages/ProductDetailPage';
import ProfilePage from './pages/ProfilePage';

function App() {
  return (
    <LanguageProvider>
      <CartProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Navigate to="/demo-hotel" replace />} />
            <Route path="/:hotelId" element={<HomePage />} />
            <Route path="/:hotelId/product/:productId" element={<ProductDetailPage />} />
            <Route path="/:hotelId/cart" element={<CartPage />} />
            <Route path="/:hotelId/confirmation" element={<ConfirmationPage />} />
            <Route path="/:hotelId/profile" element={<ProfilePage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <Toaster />
        </Router>
      </CartProvider>
    </LanguageProvider>
  );
}

export default App;